import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import NumberedCitationConverterCommand from './numberedcitationconvertercommand';
import NumberedCitationConverterEditing from './numberedcitationconverterediting';

export default class NumberedCitationConverter extends Plugin {
  static get pluginName() {
    return 'NumberedCitationConverter';
  }
  static get requires() {
    return [NumberedCitationConverterEditing, NumberedCitationConverterCommand];
  }
}